"use client";

/**
 * Toast provider wrapper.
 *
 * Thin pass-through to @speakai/ui's ToastProvider, which mounts its
 * own ToastContainer internally — adding another here would double-render
 * every toast.
 */

import { ToastProvider as SpeakToastProvider } from "@speakai/ui/toast";

export function ToastProvider({ children }: { children: React.ReactNode }) {
  return <SpeakToastProvider>{children}</SpeakToastProvider>;
}
